import { themeMode } from '../../JuvareTheme';
const isLightTheme = themeMode === 'light';
export const gradients = {
    /** @deprecated */
    blue: { backgroundImage: 'linear-gradient(45deg, #030320, #361AAA, #A81FDE)' },
    /** @deprecated */
    orange: { backgroundImage: 'linear-gradient(to right, #BF360C, #FFCC80)' },
    /** @deprecated */
    green: { backgroundImage: 'linear-gradient(to right, #388E3C, #4CAF50, #0097A7)' },
    /** @deprecated */
    lightBlue: { backgroundImage: 'linear-gradient(to right, #0E6DCE, #00BCD4)' },
    /** @deprecated */
    grey: { backgroundImage: 'linear-gradient(to right, #212121, #9E9E9E)' },
    /** @deprecated - use orange-vertical instead. */
    'orange-light': { backgroundImage: 'linear-gradient(88.37deg, #BF360C 0%, #FFCC80 100%)' },
    /** @deprecated - use orange-horizontal-left instead. */
    'orange-base': { backgroundImage: 'linear-gradient(88.37deg, #F57C00 0%, #AA182C 52.07%, #311B92 100%)' },
    /** @deprecated - use orange-horizontal-multi instead. */
    'orange-dark': { backgroundImage: 'linear-gradient(88.37deg, #BF360C 0%, #180C4B 100%)' },
    /** @deprecated - use orange-horizontal-right instead. */
    'orange-dark-linear': { backgroundImage: 'linear-gradient(88.37deg, #212121 0%, #BF360C 53.02%, #FF9800 100%)' },
    /** @deprecated - use orange-angle-multi instead. */
    'orange-dark-angle': { backgroundImage: 'linear-gradient(215.26deg, #FF9800 0%, #BF360C 47.36%, #030320 100%)' },
    /** @deprecated - use green-vertical instead. */
    'green-light': { backgroundImage: 'linear-gradient(88.37deg, #388E3C 0%, #A5D6A7 100%)' },
    /** @deprecated - use green-horizontal-left instead. */
    'green-base': { backgroundImage: 'linear-gradient(88.37deg, #4CAF50 0%, #0097A7 49.56%, #311B92 100%)' },
    /** @deprecated - use green-horizontal-multi instead. */
    'green-dark': { backgroundImage: 'linear-gradient(88.37deg, #388E3C 0%, #0097A7 51.3%, #180C4B 99.88%)' },
    /** @deprecated - use green-horizontal-right instead. */
    'green-dark-linear': { backgroundImage: 'linear-gradient(88.37deg, #212121 0%, #1B5E20 53.02%, #4CAF50 100%)' },
    /** @deprecated - use green-angle-multi instead. */
    'green-dark-angle': { backgroundImage: 'linear-gradient(215.26deg, #00BCD4 0%, #388E3C 47.36%, #030320 100%)' },
    /** @deprecated - use cyan-vertical instead. */
    'cyan-light': { backgroundImage: 'linear-gradient(88.37deg, #006064 0%, #80DEEA 100%)' },
    /** @deprecated - use cyan-horizontal-left instead. */
    'cyan-base': { backgroundImage: 'linear-gradient(88.37deg, #0097A7 0%, #063F9D 52.8%, #311B92 100%)' },
    /** @deprecated - use cyan-horizontal-multi instead. */
    'cyan-dark': { backgroundImage: 'linear-gradient(88.37deg, #0097A7 0%, #063F9D 51.57%, #180C4B 100%)' },
    /** @deprecated - use cyan-horizontal-right instead. */
    'cyan-dark-linear': { backgroundImage: 'linear-gradient(88.37deg, #212121 0%, #006064 53.02%, #00BCD4 100%)' },
    /** @deprecated - use cyan-angle-multi instead. */
    'cyan-dark-angle': { backgroundImage: 'linear-gradient(215.26deg, #80DEEA 0%, #006064 47.36%, #030320 100%)' },
    /** @deprecated - use blue-vertical instead. */
    'blue-light': { backgroundImage: 'linear-gradient(90.45deg, #0E6DCE 0.77%, #8CC5F7 99.23%)' },
    /** @deprecated - use blue-horizontal-multi instead. */
    'blue-light-angle': { backgroundImage: 'linear-gradient(0deg, #8CC5F7 0%, #0C5DBC 100%)' },
    /** @deprecated - use blue-horizontal-left instead. */
    'blue-base': { backgroundImage: 'linear-gradient(90.45deg, #0E6DCE 0.77%, #512DA8 99.23%)' },
    /** @deprecated - use blue-horizontal-multi instead. */
    'blue-dark': { backgroundImage: 'linear-gradient(90.45deg, #0E6DCE 0.77%, #512DA8 50.36%, #180C4B 99.23%)' },
    /** @deprecated - use blue-horizontal-right instead. */
    'blue-dark-linear': { backgroundImage: 'linear-gradient(88.37deg, #212121 0%, #063F9D 53.02%, #0E6DCE 100%)' },
    /** @deprecated - use blue-angle-multi instead. */
    'blue-dark-angle': { backgroundImage: 'linear-gradient(215.26deg, #00BCD4 0%, #0E6DCE 46.46%, #45052B 100%)' },
    /** @deprecated - use pink-vertical instead. */
    'pink-light': { backgroundImage: 'linear-gradient(88.37deg, #C2185B 0%, #F48FB1 100%)' },
    /** @deprecated - use pink-horizontal-left instead. */
    'pink-base': { backgroundImage: 'linear-gradient(88.37deg, #C2185B 0%, #311B92 100%)' },
    /** @deprecated - use pink-horizontal-multi instead. */
    'pink-dark': { backgroundImage: 'linear-gradient(88.37deg, #C2185B 0%, #311B92 50.89%, #180C4B 100%)' },
    /** @deprecated - use pink-horizontal-right instead. */
    'pink-dark-linear': { backgroundImage: 'linear-gradient(88.37deg, #212121 0%, #880E4F 53.02%, #E91E63 100%)' },
    /** @deprecated - use pink-angle-multi instead. */
    'pink-dark-angle': { backgroundImage: 'linear-gradient(215.26deg, #F57C00 0%, #C2185B 46.46%, #45052B 100%)' },
    /** @deprecated - use red-vertical instead. */
    'red-light': { backgroundImage: 'linear-gradient(88.37deg, #AA182C 0%, #F2989E 100%)' },
    /** @deprecated - use red-horizontal-left instead. */
    'red-base': { backgroundImage: 'linear-gradient(88.37deg, #CE0E2E 0%, #311B92 100%)' },
    /** @deprecated - use red-horizontal-multi instead. */
    'red-dark': { backgroundImage: 'linear-gradient(88.37deg, #CE0E2E 0%, #311B92 50%, #180C4B 100%)' },
    /** @deprecated - use red-horizontal-right instead. */
    'red-dark-linear': { backgroundImage: 'linear-gradient(88.37deg, #212121 0%, #AA182C 53.02%, #CE0E2E 100%)' },
    /** @deprecated - use red-angle-multi instead. */
    'red-dark-angle': { backgroundImage: 'linear-gradient(215.26deg, #F57C00 0%, #CE0E2E 46.46%, #45052B 100%)' },
    /** @deprecated - use purple-vertical instead. */
    'purple-light': { backgroundImage: 'linear-gradient(88.37deg, #512DA8 0%, #B39DDB 100%)' },
    /** @deprecated - use purple-horizontal-left instead. */
    'purple-base': { backgroundImage: 'linear-gradient(88.37deg, #673AB7 0%, #0097A7 52.9%, #311B92 100%)' },
    /** @deprecated - use purple-horizontal-multi instead. */
    'purple-dark': { backgroundImage: 'linear-gradient(88.37deg, #673AB7 0%, #311B92 50.89%, #180C4B 100%)' },
    /** @deprecated - use purple-horizontal-right instead. */
    'purple-dark-linear': { backgroundImage: 'linear-gradient(88.37deg, #212121 0%, #311B92 53.02%, #673AB7 100%)' },
    /** @deprecated - use purple-angle-multi instead. */
    'purple-dark-angle': { backgroundImage: 'linear-gradient(215.26deg, #A81FDE 0%, #361AAA 47.36%, #030320 100%)' },
    /** @deprecated - use grey-horizontal-right instead. */
    'black-dark-linear': { backgroundImage: 'linear-gradient(88.37deg, #212121 0%, #616161 53.02%, #9E9E9E 100%)' },
    /** @deprecated - use grey-angle-multi instead. */
    'black-dark-angle': { backgroundImage: 'linear-gradient(215.26deg, #BDBDBD 0%, #616161 46.64%, #030320 100%)' },
    /** @deprecated - use grey-horizontal-multi instead. */
    'grey-light-linear': {
        backgroundImage: themeMode === 'light'
            ? 'linear-gradient(90deg, #EEEEEE 0%, #F6F6F6 50%, #EEEEEE 100%)'
            : 'linear-gradient(90deg, #222222 0%, #444444 50%, #222222 100%)',
    },
    'orange-vertical': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(0deg, #B85D09 0%, #AD5707 30.16%, #522700 100%)'
            : 'linear-gradient(0deg, #5C2E04 0%, #321903 30.16%, #140A01 100%)',
    },
    'orange-horizontal-left': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(88deg, #B85D09 0%, #AD5707 30%, #522700 100%)'
            : 'linear-gradient(88deg, #5C2E04 0%, #321903 30%, #140A01 100%)',
    },
    'orange-horizontal-multi': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(88deg, #B85D09 0%, #B80E2A 70%, #520612 100%)'
            : 'linear-gradient(88deg, #5C2E04 0%, #600 70%, #140205 100%)',
    },
    'orange-horizontal-right': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(88deg, #522700 0%, #AD5707 70%, #B85D09 100%)'
            : 'linear-gradient(88deg, #140A01 0%, #321903 70%, #5C2E04 100%)',
    },
    'orange-angle-multi': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(215deg, #520612 0%, #B80E2A 30%, #B85D09 100%)'
            : 'linear-gradient(215deg, #140205 0%, #600 30%, #5C2E04 100%)',
    },
    'green-vertical': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(0deg, #138A17 0%, #108015 30.09%, #063D09 100%)'
            : 'linear-gradient(0deg, #045207 0%, #052707 30.09%, #031404 100%)',
    },
    'green-horizontal-left': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(90deg, #138A17 0.77%, #108015 30.31%, #063D09 99.23%)'
            : 'linear-gradient(90deg, #045207 0.77%, #052707 30.31%, #031404 99.23%)',
    },
    'green-horizontal-multi': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(88deg, #138A17 0%, #056C75 70%, #003338 99.88%)'
            : 'linear-gradient(88deg, #045207 0%, #014F57 70%, #001314 99.88%)',
    },
    'green-horizontal-right': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(88deg, #063D09 0%, #108015 70%, #138A17 100%)'
            : 'linear-gradient(88deg, #031404 0%, #052707 70%, #045207 100%)',
    },
    'green-angle-multi': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(215deg, #003338 0%, #056C75 30%, #138A17 100%)'
            : 'linear-gradient(215deg, #001314 0%, #014F57 30%, #045207 100%)',
    },
    'cyan-vertical': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(0deg, #06838F 0%, #056C75 30.05%, #003338 100%)'
            : 'linear-gradient(0deg, #015861 0%, #013237 30.05%, #001314 100%)',
    },
    'cyan-horizontal-left': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(90deg, #06838F 0.77%, #056C75 30.31%, #003338 99.23%)'
            : 'linear-gradient(90deg, #015861 0.77%, #013237 30.31%, #001314 99.23%)',
    },
    'cyan-horizontal-multi': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(90deg, #06838F 0.77%, #0A63B8 69.69%, #07264D 99.23%)'
            : 'linear-gradient(90deg, #015861 0.77%, #04437A 69.69%, #010B14 99.23%)',
    },
    'cyan-horizontal-right': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(88deg, #003338 0%, #056C75 70%, #06838F 100%)'
            : 'linear-gradient(88deg, #001314 0%, #013237 70%, #015861 100%)',
    },
    'cyan-angle-multi': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(215deg, #07264D 0%, #0A63B8 30%, #06838F 100%)'
            : 'linear-gradient(215deg, #010B14 0%, #04437A 30%, #015861 100%)',
    },
    'blue-vertical': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(0deg, #0978D9 0%, #0A63B8 30.05%, #07264D 100%)'
            : 'linear-gradient(0deg, #04437A 0%, #03223D 30.05%, #010B14 100%)',
    },
    'blue-horizontal-left': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(90deg, #0978D9 0.77%, #0A63B8 30.31%, #07264D 99.23%)'
            : 'linear-gradient(90deg, #04437A 0.77%, #03223D 30.31%, #010B14 99.23%)',
    },
    'blue-horizontal-multi': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(90deg, #0978D9 0.77%, #4C2BAD 69.69%, #241452 99.23%)'
            : 'linear-gradient(90deg, #04437A 0.77%, #2B0461 69.69%, #090514 99.23%)',
    },
    'blue-horizontal-right': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(88deg, #07264D 0%, #0A63B8 70%, #0978D9 100%)'
            : 'linear-gradient(88deg, #010B14 0%, #03223D 70%, #04437A 100%)',
    },
    'blue-angle-multi': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(215deg, #241452 0%, #4C2BAD 30%, #0978D9 100%)'
            : 'linear-gradient(215deg, #090514 0%, #2B0461 30%, #04437A 100%)',
    },
    'pink-vertical': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(0deg, #E01C73 0%, #CA1967 29.97%, #520A2A 100%)'
            : 'linear-gradient(0deg, #66002E 0%, #38071D 29.97%, #14030B 100%)',
    },
    'pink-horizontal-left': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(90deg, #E01C73 0.77%, #CA1967 30.31%, #520A2A 99.23%)'
            : 'linear-gradient(90deg, #66002E 0.77%, #38071D 30.31%, #14030B 99.23%)',
    },
    'pink-horizontal-multi': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(90deg, #E01C73 0.77%, #4C2BAD 69.69%, #241452 99.23%)'
            : 'linear-gradient(90deg, #66002E 0.77%, #2B0461 69.69%, #090514 99.23%)',
    },
    'pink-horizontal-right': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(88deg, #520A2A 0%, #CA1967 70%, #E01C73 100%)'
            : 'linear-gradient(88deg, #14030B 0%, #38071D 70%, #66002E 100%)',
    },
    'pink-angle-multi': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(215deg, #241452 0%, #4C2BAD 30%, #E01C73 100%)'
            : 'linear-gradient(215deg, #090514 0%, #2B0461 30%, #66002E 100%)',
    },
    'red-vertical': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(0deg, #E01134 0%, #B80E2A 29.98%, #520612 100%)'
            : 'linear-gradient(0deg, #660000 0%, #33040C 29.98%, #140205 100%)',
    },
    'red-horizontal-left': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(88deg, #E01134 0%, #B80E2A 30%, #520612 100%)'
            : 'linear-gradient(88deg, #660000 0%, #33040C 30%, #140205 100%)',
    },
    'red-horizontal-multi': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(90deg, #E01134 0.77%, #4C2BAD 69.69%, #241452 99.23%)'
            : 'linear-gradient(90deg, #660000 0.77%, #2B0461 69.69%, #090514 99.23%)',
    },
    'red-horizontal-right': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(88deg, #520612 0%, #B80E2A 70%, #E01134 100%)'
            : 'linear-gradient(88deg, #140205 0%, #33040C 70%, #660000 100%)',
    },
    'red-angle-multi': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(215deg, #241452 0%, #4C2BAD 30%, #E01134 100%)'
            : 'linear-gradient(215deg, #090514 0%, #2B0461 30%, #660000 100%)',
    },
    'purple-vertical': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(0deg, #5F36D9 0%, #4C2BAD 30.29%, #241452 100%)'
            : 'linear-gradient(0deg, #36057A 0%, #1B103D 30.29%, #090514 100%)',
    },
    'purple-horizontal-left': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(90deg, #5F36D9 0.77%, #4C2BAD 30.31%, #241452 99.23%)'
            : 'linear-gradient(90deg, #36057A 0.77%, #1B103D 30.31%, #090514 99.23%)',
    },
    'purple-horizontal-multi': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(90deg, #5F36D9 0.77%, #0A63B8 69.69%, #07264D 99.23%)'
            : 'linear-gradient(90deg, #36057A 0.77%, #04437A 69.69%, #010B14 99.23%)',
    },
    'purple-horizontal-right': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(88deg, #241452 0%, #4C2BAD 70%, #5F36D9 100%)'
            : 'linear-gradient(88deg, #090514 0%, #1B103D 70%, #36057A 100%)',
    },
    'purple-angle-multi': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(215deg, #07264D 0%, #0A63B8 30%, #5F36D9 100%)'
            : 'linear-gradient(215deg, #010B14 0%, #04437A 30%, #36057A 100%)',
    },
    'grey-vertical': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(0deg, #61789E 0%, #475975 29.75%, #222A38 100%)'
            : 'linear-gradient(0deg, #39455C 0%, #1F2632 29.75%, #0D1014 100%)',
    },
    'grey-horizontal-left': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(90deg, #61789E 0.77%, #475975 30.31%, #222A38 99.23%)'
            : 'linear-gradient(90deg, #39455C 0.77%, #1F2632 30.31%, #0D1014 99.23%)',
    },
    'grey-horizontal-multi': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(90deg, #61789E 0.77%, #475975 69.69%, #222A38 99.23%)'
            : 'linear-gradient(90deg, #39455C 0.77%, #1F2632 69.69%, #0D1014 99.23%)',
    },
    'grey-horizontal-right': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(88deg, #222A38 0%, #475975 70%, #61789E 100%)'
            : 'linear-gradient(88deg, #0D1014 0%, #1F2632 70%, #39455C 100%)',
    },
    'grey-angle-multi': {
        backgroundImage: isLightTheme
            ? 'linear-gradient(215deg, #222A38 0%, #475975 30%, #61789E 100%)'
            : 'linear-gradient(215deg, #0D1014 0%, #1F2632 30%, #39455C 100%)',
    },
};
